export default __webpack_public_path__ + "static/media/riverKlein.dcd15333.jpg";